import { useContext } from "react";
import css from "./SlideContainer.module.css";
import TabContext from "../store/tab-context";

function SlideContainer(props) {
  const tabContext = useContext(TabContext);

  return (
    <div
      className={`
        ${css.slideContainer}
        ${tabContext.value === tabContext.values.both ? css.sideBySide : null}
        `}
    >
      {props.children}
    </div>
  );
}

export default SlideContainer;
